module.exports = __webpack_public_path__ + "static/media/instalment.378b0f2b.svg";